import { Typography } from "@/components";
import { cn } from "@/libraries/cn";
import AssignmentTwoToneIcon from "@mui/icons-material/AssignmentTwoTone";
import ForumTwoToneIcon from "@mui/icons-material/ForumTwoTone";
import Button from "@mui/material/Button";
import type React from "react";

interface EmptyCaseProps {
	type?: "list" | "chat";
	title?: string;
	addLabel?: string;
	onClickAdd?: React.MouseEventHandler<HTMLButtonElement>;
	className?: string;
}

const EmptyCase = (props: EmptyCaseProps) => {
	const {
		type = "list",
		title = "Add cases for real time patient management",
		addLabel,
		onClickAdd,
		className,
	} = props;

	const Icon = type === "list" ? AssignmentTwoToneIcon : ForumTwoToneIcon;

	return (
		<div
			className={cn(
				"h-full w-full flex flex-col justify-center items-center gap-3 py-8 my-auto",
				className,
			)}
		>
			<div className="bg-white p-5 rounded-[3rem] shadow-sm shrink-0">
				<Icon className="!text-[5rem] !text-zinc-500" />
			</div>
			<Typography fontWeight={700} fontSize={16}>
				{title}
			</Typography>
			{onClickAdd && addLabel ? (
				<Button
					variant="contained"
					color="primary"
					className="!h-12 !rounded-full"
					onClick={onClickAdd}
				>
					{addLabel}
				</Button>
			) : null}
		</div>
	);
};

export default EmptyCase;
